import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import filter from 'lodash/filter';
import { mapGetters } from 'vuex';
import { buildCategoryNextLink, buildCategoryPrevLink, buildCategoryCanonical, buildCategoryAlternates } from '~/helpers/seo-helpers';
export default {
  name: 'CategorySeo',
  props: {
    seo: {
      type: Object,
      required: true
    },
    hreflang: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      required: true
    },
    hash: {
      type: String,
      required: true
    },
    path: {
      type: String,
      required: true
    },
    partialPath: {
      type: String,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locales: 'i18n/locales',
    locale: 'i18n/locale',
    baseURL: 'request/baseURL'
  }), {
    facet: function facet() {
      return this.seo.facet_opened ? this.seo.facet_opened : '';
    }
  }),
  head: function head() {
    return {
      title: "".concat(this.title, " | Maisons du Monde"),
      link: filter([buildCategoryPrevLink(this.locale, this.baseURL, this.partialPath, this.page, this.facet), buildCategoryCanonical(this.locale, this.baseURL, this.partialPath, this.page, this.facet), buildCategoryNextLink(this.locale, this.baseURL, this.partialPath, this.total, this.page, this.facet)].concat(_toConsumableArray(buildCategoryAlternates(this.baseURL, this.seo.alternate, this.hash, this.page, this.facet, this.hreflang))), function (entry) {
        return entry !== null;
      }),
      meta: [this.seo.is_indexed ? {} : {
        hid: 'robots',
        name: 'robots',
        content: 'noindex'
      }, {
        name: 'description',
        content: this.seo.meta_description
      }]
    };
  },
  render: function render(h) {
    return h(null);
  }
};